import styled from "styled-components";

export const Main = styled.div`
    width: 100%;
    height: 100%;
`;

export const ContentForms = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    height: 100%;

    @media (max-width: 780px) {
        height: auto;
        width: 100%;
    }
`;

export const Form = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    height: 100%;
    
    @media (max-width: 780px) {
        flex-direction: column;
        width: 100%;
    }
`;